import { matchPath, useLocation } from 'react-router';

import { ROUTES } from '@/constants';

import type { RouteScope } from './types';

/**
 * The region and season the URL points at.
 *
 * Matched against the pathname rather than read with `useParams`, because
 * `AppProvider` renders above `<Routes>` and so has no route match of its own.
 * `end: false` matches the scope prefix of every page underneath it.
 */
const useRouteScope = (): RouteScope => {
  const { pathname } = useLocation();

  const regionMatch = matchPath({ path: ROUTES.REGION, end: false }, pathname);
  const seasonMatch = matchPath({ path: ROUTES.APP, end: false }, pathname);

  return {
    regionId: regionMatch?.params.region,
    seasonId: seasonMatch?.params.season
  };
};

export default useRouteScope;
